import React from 'react'

import Svg, {
  ClipPath,
  Defs,
  G,
  Path,
  RadialGradient,
  Rect,
  Stop,
} from 'react-native-svg'

const AtmCard = ({ color = '#F2F7FF', ...props }) => {
  // Mobile SVG Component
  return (
    <Svg
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G clipPath="url(#clip0_1051_8073)">
        <Rect width={48} height={48} rx={8} fill="#F2F7FF" />
        <Path
          d="M41.602 35.1337L17.7806 48.1987C16.4747 48.9149 14.8333 48.4405 14.1146 47.1391L6.3352 33.0522C5.61647 31.7508 6.0925 30.1151 7.39845 29.3988L31.2198 16.3338C32.5258 15.6175 34.1671 16.0919 34.8858 17.3934L42.6653 31.4803C43.384 32.7817 42.908 34.4174 41.602 35.1337Z"
          fill="#345FA5"
        />
        <Path
          d="M8.2161 34.2068L9.38012 36.3149C9.6099 36.7309 10.1346 36.8826 10.5521 36.6536L35.682 22.871C36.0995 22.642 36.2517 22.119 36.0219 21.703L34.8579 19.5949C34.6281 19.1788 34.1034 19.0271 33.6859 19.2561L8.55602 33.0388C8.1385 33.2678 7.98632 33.7907 8.2161 34.2068Z"
          fill="white"
        />
        <Path
          d="M40.1513 43.6394L13.7571 50.1549C12.3101 50.5121 10.85 49.6317 10.4959 48.1884L6.66305 32.5665C6.30894 31.1232 7.19489 29.6636 8.64188 29.3064L35.0361 22.7909C36.4831 22.4337 37.9432 23.3142 38.2973 24.7574L42.1301 40.3794C42.4842 41.8226 41.5983 43.2822 40.1513 43.6394Z"
          fill="#457FDD"
        />
        <Path
          d="M8.1651 34.1601L8.74007 36.4978C8.85359 36.9592 9.32074 37.2409 9.78347 37.127L37.6353 30.2702C38.098 30.1563 38.3811 29.6899 38.2676 29.2285L37.6926 26.8908C37.5791 26.4294 37.1119 26.1477 36.6492 26.2617L8.79742 33.1184C8.33468 33.2323 8.05158 33.6987 8.1651 34.1601Z"
          fill="white"
        />
        <Path
          d="M35.9245 28.8879H9.35811C7.50667 28.8879 6 30.2286 6 31.8761V48.0119C6 49.6593 7.50667 51 9.35811 51H35.9245C37.776 51 39.2826 49.6593 39.2826 48.0119V31.8761C39.2826 30.2286 37.776 28.8879 35.9245 28.8879Z"
          fill="url(#paint0_radial_1051_8073)"
        />
        <Path
          d="M15.3884 37.1799H9.55484C9.12337 37.1799 8.77356 36.785 8.77356 36.2978V32.534C8.77356 32.0469 9.12337 31.6519 9.55484 31.6519H15.3884C15.8199 31.6519 16.1697 32.0469 16.1697 32.534V36.2978C16.1697 36.785 15.8199 37.1799 15.3884 37.1799Z"
          fill="url(#paint1_radial_1051_8073)"
        />
        <Rect
          x={30.4072}
          y={32.0205}
          width={6.65653}
          height={1.1056}
          rx={0.552801}
          fill="white"
        />
        <Rect
          x={9.69812}
          y={43.6293}
          width={5.54711}
          height={1.84267}
          rx={0.921336}
          fill="white"
        />
        <Rect
          x={17.0942}
          y={43.6293}
          width={5.54711}
          height={1.84267}
          rx={0.921336}
          fill="white"
        />
        <Rect
          x={24.4904}
          y={43.6293}
          width={5.54711}
          height={1.84267}
          rx={0.921336}
          fill="white"
        />
        <Rect
          x={31.8865}
          y={43.6293}
          width={5.54711}
          height={1.84267}
          rx={0.921336}
          fill="white"
        />
        <Rect
          x={32.6261}
          y={33.8632}
          width={4.43769}
          height={1.1056}
          rx={0.552801}
          fill="white"
        />
      </G>
      <Defs>
        <RadialGradient
          id="paint0_radial_1051_8073"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(36.7505 30.3274) rotate(144.528) scale(34.5083 30.3325)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint1_radial_1051_8073"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(14.9998 31.9815) rotate(141.45) scale(8.3142 7.07814)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#DCAD70" />
        </RadialGradient>
        <ClipPath id="clip0_1051_8073">
          <Rect width={48} height={48} rx={8} fill="white" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default AtmCard
